//TODO remake loaerer element
import Lottie from 'lottie-react';
import animationData from '@/assets/loader1.json';

export const Loading: React.FC = () => {
  return (
    <div id='loadingBlock' className='h-screen flex items-center justify-center'>
      <Lottie id='loadingIcon' animationData={animationData} className='w-[12%] h-[12%]' loop={true} />
    </div>
  );
};
